import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styles from './UploadUsersListContainer.module.less';
import ProgressBar from '../../../../Components/ProgressBar/ProgressBar';
import { UsersSelectors } from '../../../../Redux/modules/users/selectors';
import { UsersActions } from '../../../../Redux/modules/users/actions';
import { AppSelectors } from '../../../../Redux/modules/app/selectors';
import { getBasePath } from '../../../../Services/ApiService';
import { writeToStorage } from '../../../../Services/LocalStorageService';
import { localStorageKeys } from '../../../../Constants/Common';

const ProgressBarModel = (props) => {
  const closeConnection = (emitter) => {
    emitter.close();
    writeToStorage(localStorageKeys.USER_LIST_NOTIFICATION_IS_SHOWN, false);
    writeToStorage(localStorageKeys.USER_LIST_UPLOAD_IN_PROGRESS, false);
  };
  useEffect(() => {
    const BASE_PATH = getBasePath();
    const url = `${BASE_PATH}/stream/`;
    const eventSrc = new EventSource(url);
    eventSrc.onmessage = (msg) => {
      const result = JSON.parse(msg.data);
      props.setUploadProgress(result);
      if (result === 100) {
        closeConnection(eventSrc);
        props.switchStageToSuccess();
      }
    };
    eventSrc.onerror = (e) => {
      console.log('Stream error:', e);
      if (!eventSrc.retryCount) {
        eventSrc.retryCount = 1;
      } else if (eventSrc.retryCount < 5) {
        eventSrc.retryCount++;
      } else {
        closeConnection(eventSrc);
      }
    };
    return () => {
      eventSrc.close();
    };
  }, []);
  return (
    <div className={styles.modalContainer}>
      <div className={styles.header}>{gettext('Adding new users')}</div>
      <ProgressBar percentage={props.usersUploadProgress} />
      <div className={styles.progressText}>{`Adding ${props.validUsers || ''} users...`}</div>
      <div className={styles.text}>
        {gettext(
          'You can wait or just close this notification and check back later. When the process is complete, a full report will be sent to ',
        )}
        <span className={styles.email}>{props.userEmail}</span>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    validUsers: UsersSelectors.validUsersInUploadSelector(state),
    userEmail: AppSelectors.userSelector(state).email,
    usersUploadProgress: UsersSelectors.usersUploadProgressSelector(state),
  };
};

const mapDispatchToProps = {
  setUploadProgress: UsersActions.setUploadProgress,
  switchStageToSuccess: UsersActions.switchStageToSuccess,
};

ProgressBarModel.propTypes = {
  validUsers: PropTypes.number,
  userEmail: PropTypes.string,
  setUploadProgress: PropTypes.func,
  usersUploadProgress: PropTypes.number,
  switchStageToSuccess: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProgressBarModel);
